import type { JSX } from 'react';

import { MFormItem } from '../MFormItem/MFormItem';
import { MSelect, MSelectProps } from '../MSelect/MSelect';

export interface MFormSelectProps extends MSelectProps {
  label: string;
  tooltip?: {
    type: 'modal' | 'popover';
    title?: string;
    content: string | JSX.Element;
    icon?: 'info' | 'question';
  };
  alert?: string;
  weight?: 'light' | 'medium';
  align?: 'horizontal' | 'vertical';
  testId?: string;
}

export const MFormSelect = ({
  label,
  tooltip,
  alert,
  weight = 'medium',
  align,
  value,
  options,
  defaultValue,
  onChange,
  disabled,
  error,
  className,
  testId,
}: MFormSelectProps) => {
  return (
    <MFormItem
      label={label}
      tooltip={tooltip}
      alert={alert}
      weight={weight}
      testId={testId}
      align={align}
      className={className}>
      <MSelect
        options={options}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        disabled={disabled}
        error={error}
        testId={testId}
      />
    </MFormItem>
  );
};
